import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=60cf253c&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=60cf253c&prod&scoped=true&lang=css"
import style1 from "./FileUpload.vue?vue&type=style&index=1&id=60cf253c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf253c",
  null
  
)

export default component.exports